/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { ApiStatus, LoaderStates } from '@ibm-watson/shared/ts';
import {
  STTInstanceCreateNotRequired,
  STTInstanceCreateRequired,
  TTSInstanceCreateNotRequired,
  TTSInstanceCreateRequired,
  connectToContactCenter,
  getIntelepeerStatus,
  resetContactCenter
} from './actions';

export const initialState = {
  intelepeer: {
    status: ApiStatus.IDLE,
    state: LoaderStates.ACTIVE,
    error: null
  },
  contact_center: {
    provider: null,
    status: ApiStatus.IDLE,
    voice_gateway_webhook_url: null
  },
  // indicates whether or not the phone integration does not already
  // have speech instances
  stt_instance_create_required: false,
  tts_instance_create_required: false
};

export const reducers = {};

export const extraReducers = builder => {
  builder
    // CONNECT CONTACT CENTER
    .addCase(connectToContactCenter.pending, (state, _) => {
      state.phone.contact_center.status = ApiStatus.LOADING;
    })
    .addCase(connectToContactCenter.fulfilled, (state, _) => {
      state.phone.contact_center.status = ApiStatus.SUCCEEDED;
    })
    .addCase(connectToContactCenter.rejected, (state, _) => {
      state.phone.contact_center.status = ApiStatus.ERROR;
    })
    // RESET CONTACT CENTER
    .addCase(resetContactCenter, (state, _action) => {
      state.phone.contact_center.status = ApiStatus.IDLE;
      state.phone.intelepeer.status = ApiStatus.IDLE;
    })
    // GET INTELEPEER NUMBER
    .addCase(getIntelepeerStatus.pending, (state, _) => {
      state.phone.intelepeer.status = ApiStatus.LOADING;
      state.phone.intelepeer.status = LoaderStates.ACTIVE;
    })
    .addCase(getIntelepeerStatus.fulfilled, (state, action) => {
      state.phone.intelepeer.status = ApiStatus.IDLE;

      const status = action.payload?.status || '';
      if (status === 'available') {
        state.phone.intelepeer.status = ApiStatus.SUCCEEDED;
        state.phone.intelepeer.state = LoaderStates.SUCCESS;
      } else if (status === 'error') {
        state.phone.intelepeer.status = ApiStatus.ERROR;
        state.phone.intelepeer.state = LoaderStates.ERROR;
      } else if (status === 'provisioning') {
        state.phone.intelepeer.status = ApiStatus.LOADING;
        state.phone.intelepeer.state = LoaderStates.ACTIVE;
      }
    })
    .addCase(getIntelepeerStatus.rejected, (state, action) => {
      state.phone.intelepeer.status = ApiStatus.ERROR;
      state.phone.intelepeer.status = LoaderStates.ERROR;
      state.phone.intelepeer.status = action.error;
    })
    // SPEECH INSTANCES CHECK
    .addCase(STTInstanceCreateRequired, (state, _action) => {
      state.phone.stt_instance_create_required = true;
    })
    .addCase(STTInstanceCreateNotRequired, (state, _action) => {
      state.phone.stt_instance_create_required = false;
    })
    .addCase(TTSInstanceCreateRequired, (state, _action) => {
      state.phone.tts_instance_create_required = true;
    })
    .addCase(TTSInstanceCreateNotRequired, (state, _action) => {
      state.phone.tts_instance_create_required = false;
    });
};
